// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3FqaB","resendInfoText":"OnGoingPaymentBox_resendInfoText__3gnlC"};